import { decode } from 'js-base64'
import DOMPurify from 'dompurify'
import classnames from 'classnames'

import { Wrapper, ContentWrapper, TopImage, Content, ButtonWrap, BtnLeft, BtnRight, Group } from './Styled'

interface SystemItemProps {
  id?: any
  content?: string
  button_a?: string
  button_b?: string
  link_a?: string
  link_b?: string
  currentDisplayAnnouncement: { id?: any }
  handleCancel?: () => void
  [key: string]: any
}

export default function SystemItem(info: SystemItemProps) {
  const content = DOMPurify.sanitize(decode(info?.content ?? ''))

  const { button_a, button_b, link_a, link_b } = info

  const onAnnouncementButtonAClick = () => {
    info?.handleCancel?.()

    if (button_a && link_a) window.open(link_a, '_blank')
  }

  const onAnnouncementButtonBClick = () => {
    info?.handleCancel?.()

    if (button_b && link_b) window.open(link_b, '_blank')
  }

  return (
    <Wrapper
      className={classnames({
        visible: info.currentDisplayAnnouncement.id === info.id,
      })}
      onClick={info?.handleCancel}
    >
      <Group>
        <TopImage onClick={(e: React.MouseEvent) => e.stopPropagation()} />
        <ContentWrapper onClick={(e: React.MouseEvent) => e.stopPropagation()}>
          <Content dangerouslySetInnerHTML={{ __html: content }} />

          <ButtonWrap>
            {button_a && button_b && (
              <BtnLeft data-testid="cancel_system_announcement" aria-label="cancel_system_announcement" onClick={onAnnouncementButtonBClick}>
                {button_b}
              </BtnLeft>
            )}

            {!button_a && button_b ? (
              <BtnRight data-testid="confirm_system_announcement" aria-label="confirm_system_announcement" onClick={onAnnouncementButtonBClick}>
                {button_b}
              </BtnRight>
            ) : (
              <BtnRight data-testid="confirm_system_announcement" aria-label="confirm_system_announcement" onClick={onAnnouncementButtonAClick}>
                {button_a || '我知道了'}
              </BtnRight>
            )}
          </ButtonWrap>
        </ContentWrapper>
      </Group>
    </Wrapper>
  )
}
